import React from "react";
import { Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import "../css/profile.css";
import blob from "../img/blob.svg";
import { Button } from "@material-ui/core";
import Tilt from "react-tilt";

const Profile = () => {
  return (
    <Fragment>
      <a name="profile"></a>
      <p className="side-text-profile">PROFILE</p>
      <h2 className="section-heading">About Me</h2>
      <h3 className="section-quote">"No Pressure, No Diamonds"</h3>
      <hr />
      <Row>
        <Col lg={7} md={7} xs={12} className="profile-text">
          <p>
            Hi, I'm Samik Malhotra (aka Sam), a final year student at Thapar
            Institute of Engineering and Technology. 
            {/* I am a developer from
            India, currently, I'm a member of ACM-Thapar and
            Creative-Computing-Society . Beside's programming, I enjoy
            skateboarding, football, travelling and reading novels. */}
          </p>

          <ul>
            <li>
              I am a highly motivated and progress-focused Software Developer
              with a background in this industry. With a track record of
              initiative and dependability, I have devised strategic initiatives
              which I believe will prove valuable to the organization.
            </li>
            <li>
              Throughout the course of my career, I have perfected my operations
              management and strategic planning abilities. I am a capable and
              consistent problem-solver skilled at prioritizing and managing
              projects with proficiency.
            </li>
            {/* <li>
              In my previous role, I contributed teamwork, innovation, and
              project coordination toward team efforts and business
              improvements.
            </li> */}
            <li>
              I am progressive minded and in tune with new developments in my
              field. I have proven to be effective and collaborative with strong
              time-management talents. I enjoy collective brainstorming sessions
              which all me to coordinate activities to achieve a common goal.
            </li>
            {/* <li>Ask me about web development, I am happy to help</li> */}
            {/* <li>Fun Fact: There is something exciting coming in a month, stay tuned</li> */}
          </ul>
        </Col>
        <Col lg={5} md={5} className="profile-photo">
          {/* <img src={blob} alt='' className='blob'/> */}
          <img
            src="https://avatars.githubusercontent.com/u/72279316?v=4"
            alt="Samik Malhotra"
            className="profile-img"
          />
          <br />
          <br />
          <center>
            <a
              href="https://drive.google.com/file/d/1XFqtWF_KB9gxb3tt50u28KP8im9qRVGv/view?usp=sharing"
              target="_blank"
            >
              <Button className="project-btn">Resume</Button>
            </a>
          </center>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Profile;
